export const BREAKPOINTS = {
  PHONE: 480,
  TABLET: 640,
  DESKTOP: 960,
  DESKTOP_LG: 1280,
  DESKTOP_XL: 1480,
};
